import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { getCountryCode } from "./companyFlags";
import "flag-icons/css/flag-icons.min.css";

interface ICountryFlagProps {
    dataAreaId?: string | undefined | null;
    /** ISO 3166-1 alpha-2 code — used directly when dataAreaId isn't available */
    countryCode?: string | null;
    size?: number;
}

export default function CountryFlag({ dataAreaId, countryCode, size = 14 }: ICountryFlagProps) {
    const code = countryCode ?? getCountryCode(dataAreaId);

    if (!code) {
        return null;
    }

    return (
        <Tooltip title={dataAreaId ? `D365 Company: ${dataAreaId}` : code!.toUpperCase()} arrow>
            <Box
                sx={{
                    width: size,
                    height: size * 0.75,
                    borderRadius: "2px",
                    overflow: "hidden",
                    flexShrink: 0,
                    cursor: "default",
                    boxShadow: "0 0 0 0.5px rgba(0,0,0,0.12)",
                    filter: "saturate(0.65)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: size,
                    lineHeight: 1,
                }}
                className={`fi fi-${code.toLowerCase()}`}
            />
        </Tooltip>
    );
}
